import MultiColorProgressBar from './MultiColorProgressBar'

export default MultiColorProgressBar
